module.exports = __webpack_public_path__ + "img/kefu.6c4685a5.png";